<template>
    <div class="container-fluid">

        <div class="page-heading mb-4">
            <p class="page-eyebrow">PARTNER DIRECTORY</p>
            <h1 class="h3 mb-1 text-gray-800">Edit sponsor</h1>
            <p class="mb-0 text-muted">Update the sponsor profile and its attendee-facing details.</p>
        </div>

        <SponsorForm :id="this.$route.params.id" :is-new="false"></SponsorForm>
    </div>
</template>

<script>
import {defineComponent} from 'vue'
import SponsorForm from "@/components/master/SponsorForm.vue";

export default defineComponent({
    name: "SponsorEditPage",
    components: {SponsorForm}
})
</script>


<style scoped>
.page-heading {
    border-bottom: 1px solid #e2e6ea;
    padding-bottom: 1rem;
}

.page-eyebrow {
    color: #426cc6;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    margin: 0 0 0.35rem;
}
</style>
